import { LazyLaunchGetStartedOwaFlexPane } from 'owa-header-pane';
import { LazyLaunchGetStartedSuiteFlexPane } from 'owa-suite-header';
import { initializeGetStartedTasksLazy, enableGetStartedInListViewLazy } from 'owa-get-started';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isGetStartedInListViewEnabled } from 'owa-get-started/lib/utils/isGetStartedInListViewEnabled';
import { isGetStartedInFlexPaneEnabled } from 'owa-get-started/lib/utils/isGetStartedInFlexPaneEnabled';

export function mailNewUserRouteHandler() {
    if (isGetStartedInListViewEnabled()) {
        enableGetStartedInListViewLazy.importAndExecute();
    } else if (isGetStartedInFlexPaneEnabled()) {
        initializeGetStartedTasksLazy.import().then(getInitializeGetStartedPromise => {
            getInitializeGetStartedPromise().then(() => {
                isFeatureEnabled('fwk-o365shellheader')
                    ? LazyLaunchGetStartedSuiteFlexPane.importAndExecute()
                    : LazyLaunchGetStartedOwaFlexPane.importAndExecute();
            });
        });
    }
}
